module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block small-paddings empty-btns"
  }, [(!_vm.emptySearch) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.showEmpty
    }
  }, [_vm._v("\n    Search for Empty Entities "), _c('span', {
    ref: "showEmptyLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]) : _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.showAll
    }
  }, [_vm._v("\n    Search for All Entities "), _c('span', {
    ref: "showAllLoader",
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b518e40","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/EmptyBtns.vue
// module id = 887
// module chunks = 0